import {gql} from '@apollo/client'

export const CREATE_DISPATCH = gql`
  mutation dispatchCreate($input: DispatchInput!) {
    dispatchCreate(input: $input) {
      success
      errors {
        field
        message
      }
      dispatch {
        id
        uuid
      }
    }
  }
`
export const ANULAR_DISPATCH = gql`
  mutation cancelDispacth($input: CancelDispatchInput!) {
    cancelDispacth(input: $input) {
      errors {
        field
        message
      }
      success
    }
  }
`
